<template>
  <el-submenu
    v-if="hasPermission('feature_group:stockcheck')"
    class="side-navigator__submenu"
    index="stockcheck">
    <template slot="title">
      Stockcheck
    </template>
    <el-menu-item
      v-if="hasPermission('feature:stockcheck:audits')"
      class="side-navigator__menu-item"
      index="/audits">
      Audits
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:stockcheck:planograms')"
      class="side-navigator__menu-item"
      index="/pogs">
      Planograms
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:stockcheck:mapping')"
      class="side-navigator__menu-item"
      index="/pogs/stores">
      Mapping
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:stockcheck:metrics')"
      class="side-navigator__menu-item"
      index="/metrics/stockcheck">
      Metrics
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:stockcheck:audits')"
      class="side-navigator__menu-item"
      index="/extAudits2">
      Mobile Audits
    </el-menu-item>
  </el-submenu>
</template>

<script>
import NavigationIcon from './NavigationIcon'

export default {
  name: 'StockcheckNavigationGroup',
  components: {
    NavigationIcon,
  },
}
</script>




// WEBPACK FOOTER //
// src/components/navigation/StockcheckNavigationGroup.vue